<template>
  <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" :class="error ? 'error--text' : ''">
    <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-text-field__slot">
            <label class="v-label v-label--active theme--light" :class="error ? 'error--text' : ''" style="left: 0px; right: auto; position: absolute;">{{label}}</label>
            <money :id="id" v-bind="moneyOptions" :readonly="readonly" :disabled="disabled" :value="parseFloat(value)" @input="sendValue" ref="teste"></money>
            <!-- // Existe o v-text-field para funcionar as validações -->
            <v-text-field v-show="false" :value="value" :rules="rules"></v-text-field>
          </div>
        </div>
        <div class="v-text-field__details">
            <div class="v-messages theme--light" :class="error ? 'error--text' : ''">
              <div class="v-messages__wrapper">
                <div v-if="error" class="v-messages__message">O campo "{{label}}" é obrigatório</div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable eqeqeq */
  export default {
    name: 'PMoney',
    props: {
      id: {
        default: 'v_money'
      },
      value: {
        default: 0
      },
      label: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      rules: {
        type: Array,
        default: () => { return [] }
      }
    },
    data: () => ({
      error: false,
      moneyOptions: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }),
    mounted () {
      // Insere os eventos
      let i = 0
      // Coloca o setINterval para adicionar os eventos de click, blur e key up enter apos o componenete ser criado. os eventos são adicioandos assim pois não funcionam no v-money
      let intervalMoney = setInterval(() => {
        i++
        let inputMoney = document.getElementById(this.id)
        if (inputMoney || i > 20) {
          inputMoney.addEventListener('click', () => this.$emit('click', parseFloat(this.value)))
          inputMoney.addEventListener('blur', () => {
            this.$emit('blur', parseFloat(this.value))
            if (this.rules.length > 0) {
              this.error = this.value == '' || this.value <= 0
            }
          })
          inputMoney.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
              this.$emit('keyupEnter', parseFloat(this.value))
            }
          })
          clearInterval(intervalMoney)
        }
      }, 200)
    },
    methods: {
      sendValue (val) {
        this.$emit('input', parseFloat(val))
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PMoney.vue